var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-page",
    {
      attrs: {
        heading: (_vm.$config.auth || {}).loginHeadingOverride || "Sign In"
      }
    },
    [
      _c("login-form", {
        staticClass: "login-form",
        attrs: {
          "username-placeholder": "Email Address",
          "username-validation-rules": "required|email",
          "on-valid-submit": _vm.login,
          "username-initial-value":
            (_vm.$config.auth || {}).loginUsernameDefault || ""
        }
      }),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "forgot-password" },
        [
          _c("router-link", { attrs: { to: { name: "forgot-password" } } }, [
            _vm._v("Forgot Password?")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "register" },
        [
          _vm._v("Don't have an account? "),
          _c("router-link", { attrs: { to: { name: "register" } } }, [
            _vm._v("Sign up")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }